module.exports = __webpack_public_path__ + "files/d7bcd96b2ee985af0c7dea1579a27f2d.png";